import {
  createDeleteApiHook,
  createGetApiHook,
  createPostApiHook,
} from "../apiHooks";
import { Availability } from "../../../types/availability";
import { APIResponseType } from "../../../types/generics/APIResponse.type";

type AddAvailabilityParams = {
  gtpId: number;
  headers?: Record<string, string>;
};

type EditAvailabilityParams = {
  gtpId: number;
  id: number;
  headers?: Record<string, string>;
};

const getGTPAvailability = ({ gtpId }: { gtpId: number }) =>
  `/gtp/availability/${gtpId}`;

const setGTPAvailabilityEndpoint = ({ gtpId }: { gtpId: number }) =>
  `/gtp/availability/${gtpId}`;

const deleteGTPAvailabilityEndpoint = ({
  gtpId,
  id,
}: {
  gtpId: number;
  id: number;
}) => `/gtp/availability/${gtpId}/${id}`;

const setEditGTPAvailabilityEndpoint = ({
  gtpId,
  id,
}: {
  gtpId: number;
  id: number;
}) => `/gtp/availability/${gtpId}/${id}`;

export const useGetGTPAvailability = createGetApiHook<
  APIResponseType<Availability[]>,
  { gtpId: number }
>(getGTPAvailability);

export const useCreateGtpAvailability = createPostApiHook<
  {},
  AddAvailabilityParams,
  APIResponseType<Availability>
>(setGTPAvailabilityEndpoint, {
  isFormDataMethod: false,
});
export const useEditGtpAvailability = createPostApiHook<
  {},
  EditAvailabilityParams,
  APIResponseType<Availability>
>(setEditGTPAvailabilityEndpoint, {
  isFormDataMethod: false,
});

export const useDeleteGTPAvailability = createDeleteApiHook<
  {},
  EditAvailabilityParams,
  APIResponseType<Availability>
>(deleteGTPAvailabilityEndpoint, {
  isFormDataMethod: false,
});
